import { render, staticRenderFns } from "./testpage3.vue?vue&type=template&id=11b9b1cc&scoped=true&"
import script from "./testpage3.vue?vue&type=script&lang=js&"
export * from "./testpage3.vue?vue&type=script&lang=js&"
import style0 from "./testpage3.vue?vue&type=style&index=0&id=11b9b1cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b9b1cc",
  null
  
)

export default component.exports